module.exports = __webpack_public_path__ + "static/media/Seam_3142.f37948ae.jpg";